<form [formGroup]="partNumberForm">
    <app-picklist
        [formControl]="partNumberForm.controls['selectedPartNumbers']"
        [showValidations]="showValidations"
        [source]="availablePartNumbers"
        [target]="selectedPartNumbers"
        sourceHeader="{{'admin.tools.create-modal.pick-list.partNumbers.leftHeader' | translate}}"
        targetHeader="{{'admin.tools.create-modal.pick-list.partNumbers.rightHeader' | translate}}">
    </app-picklist>
</form>
